import { useRef } from 'react';

import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { IconFile } from '@components/icons/file';
import { IconUpload } from '@components/icons/upload';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { useStore } from 'models/Provider';

export const FileUpload = observer(({ file, disabled, error, onChange, extensions = '' }) => {
  const { t } = useStore();
  const inputRef = useRef();

  const changeFile = (e) => {
    const file = e.target.files.length > 0 ? e.target.files[0] : null;
    if (onChange) {
      onChange(file);
    }
  };

  const uploadClick = () => {
    inputRef.current.click();
  };

  return (
    <>
      <Stack space={1}>
        <Container
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              uploadClick();
            }
          }}
          tabIndex={0}
          onClick={disabled ? null : uploadClick}
          filled={file !== null}
          disabled={disabled}
          error={error}
        >
          <Stack space={3} orientation="horizontal">
            {file !== null ? (
              <>
                <IconFile color="blue100" />
                <Text font="regular16" ellipsis>
                  {file.name || file.fileName}
                </Text>
              </>
            ) : (
              <>
                <IconUpload />
                <Text color="purple50">{t('files.add')}</Text>
              </>
            )}
          </Stack>
        </Container>
        {extensions && (
          <Text font="regular14" color="purple60">
            {t('files.accepted', extensions)}
          </Text>
        )}
      </Stack>
      <input
        accept={extensions}
        ref={inputRef}
        style={{ display: 'none' }}
        type="file"
        onChange={changeFile}
      />
    </>
  );
});

const Container = styled.div((p) => ({
  padding: '0 1rem',
  display: 'flex',
  justifyContent: 'flex-start',
  backgroundColor: p.filled ? p.theme.colors.white100 : p.theme.colors.purpleTrans5,
  color: p.filled ? p.theme.colors.purple100 : p.theme.colors.purple50,
  alignItems: 'center',
  height: '2.5rem',
  borderWidth: '0.0625rem',
  borderStyle: 'solid',
  borderColor: p.filled ? p.theme.colors.purple10 : 'transparent',
  borderRadius: '0.25rem',
  cursor: 'pointer',
  ...(!p.filled && {
    ':hover, :focus': {
      color: p.theme.colors.purple80,
      backgroundColor: p.theme.colors.purpleTrans10,
      outline: 'none',
    },
  }),
}));
